import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import StarRatings from "react-star-ratings";
import axios from "../../axios";
import { API_KEY, baseUrl, imageUrl, imageUrl2 } from "../../Constants/Constance";
import CryptoJS from "crypto-js";

import Navbar from "../../components/Header/Navbar";
import Footer from "../../components/Footer/Footer";
// import useUpdateMylist from "../CustomHooks/useUpdateMylist";
// import useUpdateLikedMovies from "../CustomHooks/useUpdateLikedMovies";
import usePlayMovie from "../../CustomHooks/usePlayMovie";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axiosClient from "../../axios-client";
import usePlayVideo from "../../CustomHooks/usePlayVideo";
import { decryptId } from "../../utils/encryption";
// import usePlayMovie from "../CustomHooks/usePlayMovie";
// import useUpdateWatchedMovies from "../CustomHooks/useUpdateWatchedMovies";

function PlaySerie() {
    // const secretKeyEnv = process.env.REACT_APP_SECRET_KEY;

    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [urlId, setUrlId] = useState("");
    const [serieDetails, setSerieDetails] = useState({});
    const [isFromMyList, setIsFromMyList] = useState(false);
    const [isFromLikedMovies, setIsFromLikedMovies] = useState(false);
    const [isFromWatchedMovies, setIsFromWatchedMovies] = useState(false);
    const [moreTrailerVideos, setMoreTrailerVideos] = useState([]);
    const [similarMovies, setSimilarMovies] = useState([]);
    const [selectedSeason, setSelectedSeason] = useState(1); // Default to Season 1
    const [currentEpisodes, setCurrentEpisodes] = useState([]);
    // const { addToMyList, removeFromMyList, PopupMessage } = useUpdateMylist();
    // const { addToLikedMovies, removeFromLikedMovies, LikedMoviePopupMessage } =useUpdateLikedMovies();
    // const { removeFromWatchedMovies, removePopupMessage } =useUpdateWatchedMovies();
    const { playMovie } = usePlayMovie();
    const { playVideo } = usePlayVideo();

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    // const decryptId = (encryptedId) => {
    //     try {
    //         const key = secretKeyEnv;
    //         const decoded = atob(encryptedId);
    //         const decryptedBytes = CryptoJS.AES.decrypt(decoded, key);
    //         return decryptedBytes.toString(CryptoJS.enc.Utf8);
    //     } catch (error) {
    //         // console.error("Error decrypting token:", error);
    //         return null;
    //     }
    // };

    useEffect(() => {
        window.scrollTo(0, 0);
        if (location.state.season) {
            setSelectedSeason(location.state.season)
            fetchEpisodes(decryptId(id), location.state.season);
        }
    }, [])

    const fetchEpisodes = async (idSerie, seasonNumber) => {
        try {
            const response = await axiosClient.get(`/episodes/${idSerie}/season/${seasonNumber}/`);
            setCurrentEpisodes(response.data);
        } catch (error) {
            // console.error("Error fetching episodes:", error);
        }
    };


    const fetchSerieDetails = async (id) => {
        try {
            const response = await axiosClient.get(`/series/${id}/`);


            setSerieDetails(response.data);

            // const recommendationsResponse = await fetch(
            //     `${baseUrl}/movie/${id}/recommendations?api_key=${API_KEY}&language=en-US&page=1`
            // );
            // const recommendationsData = await recommendationsResponse.json();
            // setSimilarMovies(recommendationsData.results);
        } catch (error) {
            // console.error("Error fetching movie details or recommendations:", error);
        }
    };

    useEffect(() => {

        fetchEpisodes(decryptId(id), selectedSeason);
        fetchSerieDetails(decryptId(id));
    }, [id, selectedSeason, urlId]);


    return (
        <div>
            <Navbar playPage></Navbar>


            {serieDetails?.id ? (
                <>
                    {/* Movie details Section  */}
                    <section
                        style={{
                            backgroundImage: `linear-gradient(0deg, rgba(18, 18, 18, 0.91) 0%, rgb(0 0 0 / 64%) 60%, rgba(83, 102, 141, 0) 100%), url(${screenWidth < 700 ? serieDetails.poster : serieDetails.image})`,
                        }}
                        className="min-h-[50vh] md:min-h-[80vh] bg-cover bg-center object-contain flex flex-col items-end p-5 sm:p-14 lg:flex-row  lg:gap-8 py-24"
                    >
                        <div className="lg:w-[45%]">

                            <h1 className="text-white font-bold text-3xl mb-2">
                                {serieDetails?.title}
                            </h1>

                            <p className="text-neutral-400 mt-3">{serieDetails?.description}</p>
                            <div className=" w-full h-[0.1rem] my-5"></div>
                            <div className="gap-3 flex flex-col sm:flex-row justify-between">

                                <div className="lg:grid">
                                    {serieDetails?.releaseDate &&
                                        <h1 className=" text-orange-400 ">
                                            Sorti le :{" "}
                                            <a className="text-white ml-1">
                                                {serieDetails?.releaseDate.split("-")[0]}
                                            </a>
                                        </h1>}
                                    {serieDetails?.language &&
                                        <h1 className="text-orange-400">
                                            Langue :{" "}
                                            <a className="text-white ml-1">
                                                {serieDetails?.language}
                                            </a>
                                        </h1>
                                    }
                                    {serieDetails?.origin_country &&

                                        <h1 className="text-orange-400">
                                            Pays d'origine :{" "}
                                            <a className="text-white ml-1">
                                                {serieDetails?.origin_country}
                                            </a>
                                        </h1>
                                    }
                                    {serieDetails?.category_names?.length > 0 &&

                                        <h1 className="text-orange-400">
                                            Genres :{" "}
                                            <a className="text-white ml-1">
                                                {serieDetails?.category_names?.slice(0, 3).join(", ")}
                                            </a>
                                        </h1>
                                    }
                                    {serieDetails?.actors?.length > 0 &&

                                        <h1 className="text-orange-400">
                                            Acteurs principaux :{" "}
                                            <a className="text-white ml-1">
                                                {serieDetails.actors?.join(", ")}
                                            </a>
                                        </h1>
                                    }
                                    {serieDetails?.director_name &&

                                        <h1 className="text-orange-400">
                                            Réalisation :{" "}
                                            <a className="text-white ml-1">
                                                {serieDetails?.director_name}
                                            </a>
                                        </h1>
                                    }


                                </div>
                                <div className="flex flex-col items-end justify-start">
                                    <h1 className="flex  text-white text-lg leading-relaxed">
                                        <p className="font-medium">
                                            {serieDetails.serie_totalSeasons} Saison{serieDetails.serie_totalSeasons > 1 ? "s" : ""}

                                        </p>
                                    </h1>
                                    {serieDetails.min_age ?
                                        <div className="flex justify-end ">
                                            <p className=" px-1 border-white border-[2px] text-white font-medium w-fit text-md">+{serieDetails.min_age}</p>
                                        </div>
                                        :
                                        <div className="flex justify-end ">
                                            <p className=" text-white w-fit font-medium text-sm">Convient à tous âges</p>
                                        </div>
                                    }


                                </div>
                            </div>

                        </div>

                    </section>
                    <div className="flow-root">
                        {/* Season Selector */}
                        <div className="mt-5 flex items-center w-[80%] mx-auto py-6">
                            <select
                                id="season-select"
                                className="block w-52 p-2.5 text-white border  rounded-lg shadow-sm focus:ring-orange-500 focus:border-orange-500 bg-black/20  border-orange-500"
                                value={selectedSeason}
                                onChange={(e) => setSelectedSeason(e.target.value)}
                            >
                                {Array.from({ length: serieDetails.totalSeasons }, (_, index) => (
                                    <option
                                        key={index + 1} // Use index + 1 to start the season numbering at 1
                                        className="bg-[#231634]"
                                        value={index + 1}
                                    >
                                        Season {index + 1}
                                    </option>
                                ))}
                            </select>
                        </div>


                        {/* Divider */}
                        <div className="h-[1px] bg-gray-700 mt-4" />

                        {/* Episode List */}
                        <ul
                            role="list"
                            className="divide-y divide-gray-700 mt-4"
                        >
                            {currentEpisodes.map((episode) => (
                                <li onClick={() => playVideo(episode.id, "episode", null, null, episode?.seasonNumber)} key={episode.id} className="py-4">
                                    <div className="flex items-center space-x-3 sm:space-x-6 px-3  w-[100%] sm:w-[80%] mx-auto">
                                        <div className="text-3xl md:text-4xl font-bold text-orange-400">{episode.episodeNumber}</div>
                                        <div
                                            className="flex flex-shrink-0"
                                            onClick={() => playVideo(episode.id, "episode", null, null, episode?.seasonNumber)}
                                        >
                                            <img
                                                // className=" "
                                                className={`cursor-pointer rounded-lg  ${screenWidth < 900 ? "w-full h-[150px] sm:h-[200px] object-fill" : "w-72 h-40  transition-transform duration-300 hover:scale-105 object-cover"} `}

                                                src={screenWidth < 900 ? serieDetails.poster : serieDetails.image}
                                                alt="Episode Thumbnail"
                                            />
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <p className="text-xl md:text-3xl mb-3 font-medium text-white">
                                                {`Episode ${episode.episodeNumber}: ${episode.title}`}
                                            </p>
                                            <p className="text-sm md:text-md text-teal-300">
                                                {episode.duration < 60
                                                    ? `${episode.duration} secs`
                                                    : episode.duration < 3600
                                                        ? `${Math.floor(episode.duration / 60)} min${Math.floor(episode.duration / 60) > 1 ? "s" : ""} ${episode.duration % 60 > 0 ? `${episode.duration % 60} secs` : ""
                                                        }`
                                                        : `${Math.floor(episode.duration / 3600)} hr${Math.floor(episode.duration / 3600) > 1 ? "s" : ""} ${Math.floor((episode.duration % 3600) / 60) > 0
                                                            ? `${Math.floor((episode.duration % 3600) / 60)} min${Math.floor((episode.duration % 3600) / 60) > 1 ? "s" : ""}`
                                                            : ""
                                                        } ${episode.duration % 60 > 0 ? `${episode.duration % 60} secs` : ""}`}
                                            </p>

                                            <p className="text-sm md:text-md text-gray-300">
                                                {episode.description}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>




                </>
            ) : (
                <>
                    <div className="px-4 lg:px-10 xl:px-12 animate-pulse">
                        <div className="w-72 mt-4 sm:ml-0 sm:w-96 py-5 mb-7 xl:py-7 xl:w-45rem bg-neutral-900 rounded-md"></div>
                        <div className="w-full py-1 mb-3 xl:py-2 bg-neutral-900 rounded-md"></div>
                        <div className="w-full py-1 mb-3 xl:py-2 bg-neutral-900 rounded-md"></div>
                        <div className="w-full py-1 mb-3 xl:py-2 bg-neutral-900 rounded-md"></div>
                        <div className="w-full py-1 mb-8 xl:py-2 bg-neutral-900 rounded-md"></div>
                    </div>
                </>
            )}
            <Footer></Footer>
        </div>
    );
}

export default PlaySerie;
